// @flow

import React from "react";
import classnames from "classnames";

import { ReactComponent as SaveMain } from "./SaveMain.svg";
import { ReactComponent as SaveStrom } from "./SaveStrom.svg";
import { ReactComponent as SaveGas } from "./SaveGas.svg";
import { ReactComponent as SavePlus } from "./SavePlus.svg";

import Styles from "./Save.module.scss";
import CommonStyles from "../../Homepage.module.scss";

type Props = {
  title: string,
  fieldGroupName: string,
};

const Save = ({ title, fieldGroupName }: Props) => {
  return (
    <div
      className={classnames(CommonStyles.componentWrapper, Styles.wrapper)}
      data-fieldgroupname={fieldGroupName}
      data-cy="homepageComponent"
    >
      <div className={Styles.contentWrapper}>
        <h2>{title}</h2>
        <div className={Styles.imageContainer}>
          <div className={Styles.col1}>
            <SaveStrom className="theme-color-primary" />
            <SavePlus className="theme-color-primary" />
            <SaveGas className="theme-color-primary" />
          </div>
          <div className={Styles.col2}>
            <SaveMain className="theme-color-primary" />
            {/* <h3 className={classnames(Styles.saveAmount, "theme-color-primary")}>800€</h3> */}
          </div>
          <div className={Styles.col3}>
            <SaveGas className="theme-color-primary" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Save;
